var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cart-template", {
    attrs: {
      canBack: !_vm.isSourceSale,
      hasAlert: _vm.isSourceSale,
      isPlan: _vm.isPlanPath
    },
    scopedSlots: _vm._u([
      {
        key: "configuration",
        fn: function() {
          return [
            _c("cart-navigation", {
              attrs: {
                smallMargin:
                  _vm.isSourceSale || (!_vm.isPlanPath && !_vm.isPaymentPath),
                context: "upsell"
              }
            }),
            _vm._v(" "),
            _vm.isSourceSale && !_vm.isPaymentPath
              ? _c("expiration-message", {
                  attrs: { expirationDate: _vm.expirationDate }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isPlanPath && !_vm.isPaymentPath
              ? _c("subscription-summary", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: !_vm.previousCart.total.monthly
                        .total_amount_tax_included,
                      expression:
                        "!previousCart.total.monthly.total_amount_tax_included"
                    }
                  ],
                  attrs: { context: "upsell" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "upsellCartForm",
                attrs: {
                  "label-position": "top",
                  rules: _vm.setRules,
                  model: _vm.modelForm
                }
              },
              [_c("router-view", { attrs: { store: "upsell" } })],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "resume",
        fn: function() {
          return [
            _c(
              "cart-summary",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: !_vm.previousCart.total.monthly
                      .total_amount_tax_included,
                    expression:
                      "!previousCart.total.monthly.total_amount_tax_included"
                  }
                ],
                attrs: { context: "upsell" },
                scopedSlots: _vm._u([
                  {
                    key: "licences",
                    fn: function() {
                      return [
                        _c(
                          "ul",
                          { staticClass: "ov-auto mb-0 cart-licences-list" },
                          [
                            _vm._l(_vm.productsWithLicences, function(
                              product,
                              index
                            ) {
                              return _c(
                                "li",
                                {
                                  key: product.code,
                                  staticClass: "flex-row",
                                  class: {
                                    "mb-2":
                                      index + 1 !==
                                      _vm.productsWithLicences.length
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("p", { staticClass: "grey m-0 fs-3" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$l10n.n__(
                                              "%(total)s licence %(productsName)s",
                                              "%(total)s licences %(productsName)s",
                                              _vm.products[product.id].quantity,
                                              {
                                                total:
                                                  _vm.products[product.id]
                                                    .quantity,
                                                productsName: product.title
                                              }
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.freeLicencesByProduct(product.id)
                                      ? _c("span", { staticClass: "grey" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$l10n.n__(
                                                "Dont %s offerte",
                                                "Dont %s offertes",
                                                _vm.freeLicencesByProduct(
                                                  product.id
                                                ),
                                                _vm.freeLicencesByProduct(
                                                  product.id
                                                )
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.products[product.id].total
                                    ? [
                                        _vm.freeLicencesByProduct(product.id)
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "flex-item-right my-0"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "strike grey semibold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$filters.numberFormatToFloatWithOptions(
                                                          _vm.products[
                                                            product.id
                                                          ].total.monthly
                                                            .total_amount,
                                                          _vm.numformat,
                                                          true
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "success-50 fs-3 pl-2 semibold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$filters.numberFormatToFloatWithOptions(
                                                          _vm.products[
                                                            product.id
                                                          ].total.monthly
                                                            .total_amount_discounted,
                                                          _vm.numformat,
                                                          true
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      { staticClass: "fs-2" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$l10n.__(
                                                              "/mois"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "flex-item-right my-0 fs-3 semibold grey"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$filters.numberFormatToFloatWithOptions(
                                                        _vm.products[product.id]
                                                          .total.monthly
                                                          .total_amount_discounted,
                                                        _vm.numformat,
                                                        true
                                                      )
                                                    )
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "fs-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$l10n.__("/mois")
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.packsWithLicences.concat(
                                _vm.groupedPacksWithLicences
                              ),
                              function(product, index) {
                                return _c(
                                  "li",
                                  {
                                    key: product.code,
                                    staticClass: "flex-row",
                                    class: {
                                      "mb-2":
                                        index + 1 !==
                                        _vm.packsWithLicences.concat(
                                          _vm.groupedPacksWithLicences
                                        ).length,
                                      "mt-2": index === 0
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "p",
                                        { staticClass: "grey m-0 fs-3" },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$l10n.__(
                                                  "Module %(productsName)s",
                                                  {
                                                    productsName: !!product
                                                      .groups.length
                                                      ? product.printableName
                                                      : product.title
                                                  }
                                                )
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.products[product.id].total
                                      ? [
                                          _vm.products[product.id].total.monthly
                                            .total_amount_discounted <
                                          _vm.products[product.id].total.monthly
                                            .total_amount
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "flex-item-right my-0 semibold"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "strike grey semibold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$filters.numberFormatToFloatWithOptions(
                                                            _vm.products[
                                                              product.id
                                                            ].total.monthly
                                                              .total_amount,
                                                            _vm.numformat,
                                                            true
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "success-50 fs-3 pl-2"
                                                    },
                                                    [
                                                      _vm.products[product.id]
                                                        .total.monthly
                                                        .total_amount_discounted !==
                                                      0
                                                        ? [
                                                            _vm._v(
                                                              "\n                                        " +
                                                                _vm._s(
                                                                  _vm.$filters.numberFormatToFloatWithOptions(
                                                                    _vm
                                                                      .products[
                                                                      product.id
                                                                    ].total
                                                                      .monthly
                                                                      .total_amount_discounted,
                                                                    _vm.numformat,
                                                                    true
                                                                  )
                                                                )
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "fs-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$l10n.__(
                                                                      "/mois"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        : [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$l10n.__(
                                                                  "Offert"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "flex-item-right my-0 fs-3 semibold grey"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$filters.numberFormatToFloatWithOptions(
                                                          _vm.products[
                                                            product.id
                                                          ].total.monthly
                                                            .total_amount_discounted,
                                                          _vm.numformat,
                                                          true
                                                        )
                                                      )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "fs-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$l10n.__("/mois")
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              }
                            )
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "subtotal",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-column fs-3 cart-recap-total-label"
                          },
                          [
                            _c("span", { staticClass: "mb-2" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Sous-total")))
                            ]),
                            _vm._v(" "),
                            _vm.taxRate && _vm.taxRate !== 0
                              ? _c("span", { staticClass: "mb-2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$l10n.__("TVA")) +
                                      " (" +
                                      _vm._s(_vm.taxRate) +
                                      "%)"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "bold" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Total")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isYearly
                          ? _c(
                              "div",
                              { staticClass: "flex-column aright fs-3" },
                              [
                                _c("span", { staticClass: "semibold mb-2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.totalYearly.total_amount_discounted,
                                        _vm.numformat,
                                        true
                                      )
                                    )
                                  ),
                                  _c("span", { staticClass: "fs-2" }, [
                                    _vm._v(_vm._s(_vm.$l10n.__("/an")))
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.taxRate && _vm.taxRate !== 0
                                  ? _c(
                                      "span",
                                      { staticClass: "semibold mb-2" },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                _vm.totalYearly
                                                  .total_amount_vat,
                                                _vm.numformat,
                                                true
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.totalYearly
                                          .total_amount_tax_included,
                                        _vm.numformat,
                                        true
                                      )
                                    )
                                  ),
                                  _c("span", { staticClass: "fs-2" }, [
                                    _vm._v(_vm._s(_vm.$l10n.__("/an")))
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isMonthly
                          ? _c(
                              "div",
                              { staticClass: "flex-column aright fs-3" },
                              [
                                _c("span", { staticClass: "semibold mb-2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.totalMonthly
                                          .total_amount_discounted,
                                        _vm.numformat,
                                        true
                                      )
                                    )
                                  ),
                                  _c("span", { staticClass: "fs-2" }, [
                                    _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.taxRate && _vm.taxRate !== 0
                                  ? _c(
                                      "span",
                                      { staticClass: "semibold mb-2" },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$filters.numberFormatToFloatWithOptions(
                                                _vm.totalMonthly
                                                  .total_amount_vat,
                                                _vm.numformat,
                                                true
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.totalMonthly
                                          .total_amount_tax_included,
                                        _vm.numformat,
                                        true
                                      )
                                    )
                                  ),
                                  _c("span", { staticClass: "fs-2" }, [
                                    _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                                  ])
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "total",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "flex-row jc-space",
                            class: { "mb-4": !_vm.isPaymentPath }
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "fs-4 my-0 bold cart-recap-total-label--cta"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.labelTotalTaxIncluded) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isYearly
                              ? _c(
                                  "p",
                                  { staticClass: "fs-4 my-0 aright bold" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.numberFormatToFloatWithOptions(
                                            _vm.totalProrated.yearly
                                              .total_tax_included,
                                            _vm.numformat,
                                            true,
                                            _vm.numformat,
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isMonthly
                              ? _c(
                                  "p",
                                  { staticClass: "fs-4 my-0 aright bold" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.numberFormatToFloatWithOptions(
                                            _vm.totalProrated.monthly
                                              .total_tax_included,
                                            _vm.numformat,
                                            true,
                                            _vm.numformat,
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "actions",
                    fn: function() {
                      return [
                        _vm.isPaymentPath
                          ? [
                              _c("span", {
                                staticClass: "separator block my-3"
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "block fs-2 grey semibold mt-4 mb-2"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "La prochaine facture sera calculée prorata temporis"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("CompassButton", {
                          staticClass: "wp-10",
                          attrs: {
                            label: _vm.labelButton,
                            type: "primary",
                            size: "medium",
                            disabled: !_vm.cartUpselled || _vm.computeLoading,
                            leftIcon: _vm.isPaymentPath ? "lock-fill" : "",
                            loading: _vm.computeLoading
                          },
                          on: {
                            click: function($event) {
                              return _vm.submitForm(
                                "upsellCartForm",
                                "nextAction"
                              )
                            }
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _vm._v(" "),
                _vm._v(" "),
                _c("span", { staticClass: "separator block my-3" }),
                _vm._v(" "),
                _c("article", { staticClass: "flex-row jc-space" }, [
                  _c(
                    "div",
                    { staticClass: "flex-column fs-3 cart-recap-total-label" },
                    [
                      _c("span", { staticClass: "mb-3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$l10n.__("Sous-total supplémentaire estimé")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.taxRate && _vm.taxRate !== 0
                        ? _c("span", { staticClass: "mb-3" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$l10n.__("TVA supplémentaire estimée")
                              ) +
                                " (" +
                                _vm._s(_vm.taxRate) +
                                "%)"
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isYearly
                    ? _c("div", { staticClass: "flex-column aright fs-3" }, [
                        _c("span", { staticClass: "semibold mb-3" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.numberFormatToFloatWithOptions(
                                _vm.totalYearly.total_amount_discounted -
                                  _vm.previousCart.total.yearly
                                    .total_amount_discounted,
                                _vm.numformat,
                                true
                              )
                            ) + _vm._s(_vm.$l10n.__("/an"))
                          )
                        ]),
                        _vm._v(" "),
                        _vm.taxRate && _vm.taxRate !== 0
                          ? _c("span", { staticClass: "semibold mb-3" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$filters.numberFormatToFloatWithOptions(
                                      _vm.totalYearly.total_amount_vat -
                                        _vm.previousCart.total.yearly
                                          .total_amount_vat,
                                      _vm.numformat,
                                      true
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMonthly
                    ? _c("div", { staticClass: "flex-column aright fs-3" }, [
                        _c("span", { staticClass: "semibold mb-3" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.numberFormatToFloatWithOptions(
                                _vm.totalMonthly.total_amount_discounted -
                                  _vm.previousCart.total.monthly
                                    .total_amount_discounted,
                                _vm.numformat,
                                true
                              )
                            ) + _vm._s(_vm.$l10n.__("/mois"))
                          )
                        ]),
                        _vm._v(" "),
                        _vm.taxRate && _vm.taxRate !== 0
                          ? _c("span", { staticClass: "semibold mb-3" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$filters.numberFormatToFloatWithOptions(
                                      _vm.totalMonthly.total_amount_vat -
                                        _vm.previousCart.total.monthly
                                          .total_amount_vat,
                                      _vm.numformat,
                                      true
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }